import { jsx as _jsx } from "react/jsx-runtime";
import { mdiCheck } from '@mdi/js';
import { orange } from '@mui/material/colors';
import { defineStyles, theme } from '../../theme';
import { FilterButton } from './FilterButton';
const text = {
    id: 'tableFiltering.applyFilters.button',
    defaultMessage: 'Apply filters',
};
const styles = defineStyles({
    disabled: {
        color: theme.vars.palette.grey[500],
        bgcolor: theme.vars.palette.grey[200],
        borderColor: theme.vars.palette.grey[300],
        '&:hover': {
            color: theme.vars.palette.grey[500],
            bgcolor: theme.vars.palette.grey[200],
            borderColor: theme.vars.palette.grey[300],
        },
    },
    active: {
        borderColor: orange[700],
        backgroundColor: orange[500],
        color: theme.vars.palette.common.white,
        '&:hover': {
            borderColor: orange[700],
            backgroundColor: orange[500],
            opacity: 0.8,
        },
    },
});
export const ApplyFiltersButton = ({ sx, disabled }) => (_jsx(FilterButton, { sxAdditions: { ...sx, ...(disabled ? styles.disabled : styles.active) }, text: text, icon: mdiCheck, type: "submit", disabled: disabled }));
//# sourceMappingURL=ApplyFiltersButton.js.map